import { Article } from '@/entities/blog-page/Article/ui/Article'
import './ui/Article.scss'
export default Article
